module.exports = "<div class=\"card sponsored\">\r\n  <div class=\"card-body\">\r\n    <h6>Sponsor</h6>\r\n    <div *ngFor=\"let topic of sponsoredTopic\">\r\n        <a href=\"{{topic.type}}/{{topic.name}}\" class=\"card-text tag\">#{{topic.name}}</a>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/sponsored-topic/sponsored-topic.component.html
// module id = ../../../../../src/app/sponsored-topic/sponsored-topic.component.html
// module chunks = main